export function getIndexName(e){return e.join("||")}export var CLEANUP_INDEX=["_deleted","_meta.lwt"];export var INDEX_NAME_CLEANUP=getIndexName(CLEANUP_INDEX);